import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-limited-time-deals',
  templateUrl: './limited-time-deals.component.html',
  styleUrls: ['./limited-time-deals.component.scss'],
})
export class LimitedTimeDealsComponent implements OnInit {
  @Input() data: Array<any> = [];
  dataval: Array<any> = [];
  ngOnInit(): void {}
  async ngOnChanges(changes: SimpleChanges) {
    this.dataval = this.data;
  }
}
